import { ApiService } from "@/api";

export default {
  UPDATE_CLIENT(context, { id, data }) {
    return ApiService.client.update(id, data);
  },
  UPDATE_CLIENT_FBS({ commit }, { id, is_fbs }) {
    return ApiService.client.updateFbs(id, is_fbs);
  },
  GET_CLIENT({ commit }, id) {
    return ApiService.client.get(id).then((client) => commit("SET_CLIENT", client));
  },
  GET_CLIENT_FBS({ commit }, id) {
    return ApiService.client.getFbs(id).then((fbs) => commit("SET_CLIENT_FBS", fbs));
  },
  ADD_CLIENT(context, newClient) {
    return ApiService.client.create(newClient).then((data) => data.id_account);
  },
  GET_CLIENT_CAMERAS({ commit }, { clientId, showDeleted }) {
    return ApiService.client.getCameras(clientId, showDeleted).then((cameras) => {
      commit("SET_CLIENT_CAMERAS", cameras);
    });
  },
  GET_CLIENT_SHARED_CAMERAS({ commit }, id) {
    return ApiService.client.getSharedCameras(id).then((sharedCameras) => {
      commit("SET_CLIENT_SHARED_CAMERAS", sharedCameras);
    });
  },
  GET_CLIENT_INTERCOMS({ commit }, id) {
    return ApiService.client.getClientIntercoms(id).then((intercoms) => {
      commit("SET_CLIENT_INTERCOMS", intercoms.data);
    });
  },
  ADD_CLIENT_INTERCOM(context, newClientIntercom) {
    return ApiService.client.createClientIntercom(newClientIntercom.clientId, newClientIntercom.payload);
  },
  DELETE_CLIENT_INTERCOM(context, payload) {
    return ApiService.client.deleteClientIntercom(payload.clientId, payload.idIntercom);
  },
  DELETE_CLIENT(context, id) {
    return ApiService.client.delete(id);
  },
  GET_OPERATOR_PARAMETERS({ commit }) {
    return ApiService.cameras
      .getParameters()
      .then((data) => {
        commit("SET_OPERATOR_PARAMETERS", data);
        return data;
      });
  },
};
